export default __webpack_public_path__ + "static/drumsticks-8507e78dcc05ed2275a1560dda909666.jpg";